// Course download links mapping
// This maps course IDs to their Google Drive download links
const courseDownloadLinks = {
  1: "https://drive.google.com/drive/folders/1py4eZNi3R_1YhAF-9lA0bzvBttBsqkty?usp=sharing", // Hackers Library Bundle
};

/**
 * Get the download link for a specific course
 * @param {number} courseId - The ID of the course
 * @returns {string|null} - The Google Drive download link or null if not found
 */
export const getCourseDownloadLink = (courseId) => {
  return courseDownloadLinks[courseId] || null;
};

/**
 * Check if a course has a download link available
 * @param {number} courseId - The ID of the course
 * @returns {boolean} - True if download link exists, false otherwise
 */
export const hasCourseDownloadLink = (courseId) => {
  return courseId in courseDownloadLinks;
};

/**
 * Get all available course download links
 * @returns {Object} - Object containing all course download links
 */
export const getAllCourseDownloadLinks = () => {
  return { ...courseDownloadLinks };
};

export default courseDownloadLinks;
